import React from "react";
import { connect } from "react-redux";
import { Translate, I18n } from "react-redux-i18n";
import alertify from "alertifyjs";
import "../components/styles/Alertify.css";
import "../components/styles/AlertifyTheme.css";
import "../components/styles/Alertify.min.css";
import "../components/styles/AlertifyTheme.min.css";
import * as actions from "../redux/actions/sessionActions";
import "./styles/RegisterSuccessfull.css";

class AdminLogin extends React.Component {
  state = {
    loading: true,
    error: "",
  };

  componentDidMount() {
    this.loginAsUser();
  }

  loginAsUser = async () => {
    const rawToken = this.props.match?.params?.token;
    if (!rawToken) {
      this.setState({ loading: false, error: "try_later" });
      return;
    }

    const token = decodeURIComponent(rawToken);

    try {
      const result = await this.props.AdminLogin(token);
      if (result?.ok) {
        this.props.history.replace("/profile");
        return;
      }

      this.setState({
        loading: false,
        error: result?.error || "try_later",
      });
      alertify.warning(I18n.t(result?.error || "try_later"));
    } catch (error) {
      console.log(error);
      this.setState({ loading: false, error: "try_later" });
    }
  };

  render() {
    const { loading, error } = this.state;

    return (
      <div className="register-success-page">
        <div className="register-success-card">
          <div className="register-success-card__icon register-success-card__icon--muted">
            {loading ? "…" : "!"}
          </div>
          <h1 className="register-success-card__title">
            <Translate value={loading ? "login" : "warning"} />
          </h1>
          {loading && (
            <p className="register-success-card__text">
              Abriendo sesión del usuario…
            </p>
          )}
          {!loading && (
            <p className="register-success-card__text">{I18n.t(error)}</p>
          )}
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  AdminLogin: (token) => dispatch(actions.adminLoginRequest(token)),
});

export default connect(null, mapDispatchToProps)(AdminLogin);
